import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'rmt-contact-list-item',
  templateUrl: 'rmt-contact-list-item.html'
})
export class RmtContactListItem {
  @Input() data: any;
  @Input() canShowBadge: boolean = false;
  @Input() badgeIcon: string = "";
  @Input() thumbNailText: string = "";
  @Input() primaryText: string = "";
  @Input() secondaryText: string = "";
  @Input() isActionButtonRequired: boolean = false;
  @Input() actionButtonText: string = "";
  @Input() canShowChevron: boolean = false;
  @Input() canShowRadio: boolean = false;
  @Input() canShowThumbnail: boolean = false;
  @Input() thumbnailIcon: string = "";
  @Output() actionButtonClickEmitter = new EventEmitter();
  @Output() itemSelectedEmitter = new EventEmitter();
  @Output() radioButtonSelectedEmitter = new EventEmitter();
  constructor() {
  }

  setThumbnailStyle(data:any): Object {
    if(data.IsStyleSet !==  true){
      const randomColor = "#" + Math.floor(Math.random()*16444215).toString(16);
      data.IsStyleSet = true;
      data.Style = { background: randomColor+'50', color: randomColor};
    }
    return data.Style;
  }

  onActionBtnClick(event, data){
    this.actionButtonClickEmitter.emit(data);
    event.stopPropagation();
  }

  onListItemClick(data){
    if(this.canShowChevron === true || this.canShowRadio === true){
      this.itemSelectedEmitter.emit(data);
    }
  }

  onRadiobuttonClick(data){
    this.radioButtonSelectedEmitter.emit(data);
  }

}



// WEBPACK FOOTER //
// ./src/components/rmt-contact-list-item/rmt-contact-list-item.ts